import { render, staticRenderFns } from "./SnapshotManagement.vue?vue&type=template&id=f852db96&scoped=true&"
import script from "./SnapshotManagement.vue?vue&type=script&lang=js&"
export * from "./SnapshotManagement.vue?vue&type=script&lang=js&"
import style0 from "./SnapshotManagement.vue?vue&type=style&index=0&id=f852db96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f852db96",
  null
  
)

export default component.exports